import lang from "i18next";
import { TodoResult } from "./todoResult";
import { SeverityLevel } from "../../common/severityLevel";
import { SettingsRouteConsts } from "../../views/SettingsRouteConsts";
import { tTodos } from "../../i18n";
import UserPermission from "../../models/users/userPermission";
import { AccessKeysApi } from "../../common/api/payThemApi/accessKeysApi";

/*
 * Creates any required accesskey todos
 */
export async function accessKeysTodo(): Promise<TodoResult[]> {
  const api = new AccessKeysApi();
  const count = await api.countKeys();
  const results: TodoResult[] = [];
  if (count === 0) {
    results.push({
      severity: SeverityLevel.Informational,
      title: lang.t("todos.accessKeys.titleCreateAccessKeys", tTodos),
      message: lang.t("todos.accessKeys.messageCreateAccessKeys", tTodos),
      url: SettingsRouteConsts.AccessKeys,
      requiredPermissionToFix: UserPermission.ManageAccessKeys
    });
  }
  return results;
}
export default accessKeysTodo;
